import React from 'react';
import { Button } from '../Button';
import { Separator } from '../Separator';
type QA = {
  q: string;
  a: string;
};
type Category = {
  title: string;
  items: QA[];
};
const categories: Category[] = [{
  title: 'Trust & Security',
  items: [{
    q: "Will my leads know they're talking to AI?",
    a: 'Answer: The AI introduces itself transparently and sounds natural. Most leads engage as if speaking with a knowledgeable rep.'
  }, {
    q: "Is my data and my customers' data secure?",
    a: 'Answer: All data is encrypted in transit and at rest, and we never share or sell it. Formal compliance certifications are on our roadmap.'
  }, {
    q: 'What types of businesses does this work for?',
    a: 'Answer: Any service business with inbound leads — plumbing, HVAC, legal, real estate, agencies, and more.'
  }]
}, {
  title: 'Getting Started',
  items: [{
    q: 'How long does it take to get set up?',
    a: 'Answer: Most teams are live within a few business days after we train the AI on your playbook.'
  }, {
    q: 'Can I customize what the AI says to my leads?',
    a: 'Answer: Yes — you control the script, tone, qualifying questions, and edge-case handling.'
  }]
}, {
  title: 'How It Works',
  items: [{
    q: "What happens if the AI can't answer a question?",
    a: 'Answer: It hands off to a human rep, schedules a follow-up, or escalates per your configured rules.'
  }, {
    q: 'How is this different from a traditional answering service?',
    a: 'Answer: It actually qualifies leads, books meetings, and follows your sales playbook — not just message-taking.'
  }, {
    q: 'Does the AI place phone calls to leads?',
    a: "Answer: Not today — speed-to-lead currently engages leads over text and email only. We're holding off on voice until we can deliver a customer experience that matches a great human rep, and we'll add it as soon as we can."
  }]
}, {
  title: 'Compatibility & Flexibility',
  items: [{
    q: 'What if I want to cancel?',
    a: 'Answer: No contracts. Cancel anytime — 30-day money-back guarantee on your first month.'
  }, {
    q: 'Do I still need my closing sales reps?',
    a: 'Answer: Yes. The AI handles speed-to-lead and qualification; your reps focus on closing high-intent meetings.'
  }]
}];
export function FaqGallery() {
  return <section id="faq" className="w-full bg-navy-500 text-white px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24 scroll-mt-20" data-id="element-64">
      <div className="mx-auto max-w-[1280px]" data-id="element-65">
        {/* Header */}
        <div className="flex flex-col items-center gap-4 text-center max-w-2xl mx-auto mb-10 sm:mb-14" data-id="element-66">
          <div className="text-[11px] uppercase tracking-[0.2em] text-gray-400 font-semibold" data-id="element-67">
            We know what you're thinking
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white tracking-tight leading-[1.1]" data-id="element-68">
            Every question you have — before you ask it.
          </h2>
          <p className="text-base text-gray-400 leading-relaxed" data-id="element-69">
            Real answers to the doubts that hold smart businesses back.
          </p>
        </div>

        {/* 2x2 grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start" data-id="element-70">
          {categories.map(cat => <div key={cat.title} className="border border-navy-800 rounded-2xl bg-navy-800 overflow-hidden" data-id="element-71">
              <div className="px-5 sm:px-6 pt-5 sm:pt-6 pb-4 flex items-center gap-3" data-id="element-72">
                <div className="w-8 h-0.5 bg-white" aria-hidden data-id="element-73" />
                <h3 className="text-sm font-semibold text-white uppercase tracking-[0.1em]" data-id="element-74">
                  {cat.title}
                </h3>
              </div>
              <div className="px-5 sm:px-6 pb-5 sm:pb-6 pt-2 flex flex-col gap-5" data-id="element-75">
                {cat.items.map(item => <div key={item.q} className="flex flex-col gap-1.5" data-id="element-76">
                    <div className="text-sm font-semibold text-white leading-snug" data-id="element-77">
                      {item.q}
                    </div>
                    <div className="text-sm text-gray-400 leading-relaxed" data-id="element-78">
                      {item.a}
                    </div>
                  </div>)}
              </div>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 sm:mt-20 flex flex-col items-center gap-6 text-center" data-id="element-79">
          <Separator color="#14315A" className="max-w-[60px]" data-id="element-80" />

          <h3 className="text-2xl sm:text-2xl lg:text-3xl font-semibold text-white tracking-tight leading-tight" data-id="element-81">
            Still not sure? Good — skeptics make the best customers.
          </h3>
          <p className="text-base text-gray-400 max-w-2xl leading-relaxed" data-id="element-82">
            Book a free 15-minute demo. No pitch deck, no pressure — just a live
            walkthrough of how it works for your business.
          </p>

          <div className="flex flex-wrap gap-3 justify-center" data-id="element-83">
            <Button variant="primary" size="large" rightIcon={<span aria-hidden data-id="element-85">→</span>} className="!bg-orange-brand-500 !border-orange-brand-500 hover:!bg-orange-brand-600 hover:!border-orange-brand-600" data-id="element-84">
              Book a Demo
            </Button>
            <Button variant="secondary" size="large" data-id="element-86">
              Watch Demo
            </Button>
          </div>
        </div>
      </div>
    </section>;
}